import { useCustomerTaskCommentsApi, parseFilterParams } from '@pages/customers'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const customerId = to.params.id

  if (typeof customerId !== 'string' || !customerId) return

  const filters = parseFilterParams(to.query)

  void useCustomerTaskCommentsApi({
    customerId,
    disciplineId: filters.discipline_id,
    createdFrom: filters.created_from,
    createdTo: filters.created_to,
    team: filters.team,
    taskType: filters.task_type,
  })
})